import lang from '../../../lib/language';

export const PAYOUT_RULES = (buyingPower: string) => [
  lang.firstPayoutRule(),
  lang.secondPayoutRule(),
  lang.thirdPayoutRule(buyingPower),
  lang.fourthPayoutRule(),
  lang.fifthPayoutRule(),
];
export const PAYOUT_RULES2 = [
  lang.sixthPayoutRule(),
  lang.seventhPayoutRule(),
  lang.eighthPayoutRule(),
];
